module.exports = __webpack_public_path__ + "img/website char sheet.c456d7c9.png";